var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_421_11283)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 24,
    height: 23,
    rx: 5,
    fill: "#00B3E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.794 17.5684C21.2107 18.2484 20.5117 18.784 19.6916 19.1636C19.5398 19.2344 19.3668 19.2538 19.187 19.3039C19.014 19.239 18.8344 19.1991 18.6793 19.1151C15.6548 17.4186 13.3979 15.0287 11.9144 11.9427C11.1363 10.3282 10.6684 8.62868 10.4789 6.85433C10.4461 6.54966 10.4337 6.24007 10.4442 5.93125C10.4525 5.68701 10.5886 5.48646 10.7805 5.33278C11.5216 4.74246 12.3625 4.34103 13.2946 4.13103C13.8215 4.01123 14.329 4.29269 14.5043 4.79614C14.8393 5.75754 15.1685 6.71875 15.4947 7.68547C15.6121 8.03517 15.5435 8.36169 15.304 8.64585C15.0406 8.96011 14.7687 9.26847 14.4968 9.57682C14.4311 9.65047 14.4204 9.71194 14.4546 9.80305C15.0765 11.3644 15.9654 12.7635 17.1329 13.9921C17.2078 14.0705 17.273 14.0952 17.3803 14.0652C17.763 13.9629 18.1482 13.8692 18.5306 13.7755C18.9332 13.6767 19.2863 13.7674 19.5839 14.0558C20.2932 14.7376 21.0053 15.4196 21.7175 16.1015C22.1682 16.53 22.2008 17.0932 21.794 17.5684Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_421_11283",
    x: 0,
    y: 0,
    width: 32,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_421_11283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_421_11283",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderPhone);
export default __webpack_public_path__ + "static/media/header-phone.45166fb539a8e0ab391a6d13fbc42b91.svg";
export { ForwardRef as ReactComponent };